import React, { Component } from 'react';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';

import PropTypes from 'prop-types';
import SvgIcon from '@mui/material/SvgIcon';
import { alpha, styled } from '@mui/material/styles';
import TreeView from '@mui/lab/TreeView';
import TreeItem, { treeItemClasses } from '@mui/lab/TreeItem';
import Collapse from '@mui/material/Collapse';

import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import AlertTitle from '@mui/material/AlertTitle';

import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import Input from '@mui/material/Input';
import FilledInput from '@mui/material/FilledInput';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

function MinusSquare(props) {
  return (
    <SvgIcon fontSize="inherit" style={{ width: 14, height: 14 }} {...props}>
      {/* tslint:disable-next-line: max-line-length */}
      <path d="M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 11.023h-11.826q-.375 0-.669.281t-.294.682v0q0 .401.294 .682t.669.281h11.826q.375 0 .669-.281t.294-.682v0q0-.401-.294-.682t-.669-.281z" />
    </SvgIcon>
  );
}

function PlusSquare(props) {
  return (
    <SvgIcon fontSize="inherit" style={{ width: 14, height: 14 }} {...props}>
      {/* tslint:disable-next-line: max-line-length */}
      <path d="M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 12.977h-4.923v4.896q0 .401-.281.682t-.682.281v0q-.375 0-.669-.281t-.294-.682v-4.896h-4.923q-.401 0-.682-.294t-.281-.669v0q0-.401.281-.682t.682-.281h4.923v-4.896q0-.401.294-.682t.669-.281v0q.401 0 .682.281t.281.682v4.896h4.923q.401 0 .682.281t.281.682v0q0 .375-.281.669t-.682.294z" />
    </SvgIcon>
  );
}

function CloseSquare(props) {
  return (
    <SvgIcon
      className="close"
      fontSize="inherit"
      style={{ width: 14, height: 14 }}
      {...props}
    >
      {/* tslint:disable-next-line: max-line-length */}
      <path d="M17.485 17.512q-.281.281-.682.281t-.696-.268l-4.12-4.147-4.12 4.147q-.294.268-.696.268t-.682-.281-.281-.682.294-.669l4.12-4.147-4.12-4.147q-.294-.268-.294-.669t.281-.682.682-.281.696 .268l4.12 4.147 4.12-4.147q.294-.268.696-.268t.682.281 .281.669-.294.682l-4.12 4.147 4.12 4.147q.294.268 .294.669t-.281.682zM22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0z" />
    </SvgIcon>
  );
}



const StyledTreeItem = styled((props) => (
  <TreeItem {...props} />
))(({ theme }) => ({
  [`& .${treeItemClasses.iconContainer}`]: {
    '& .close': {
      opacity: 0.3,
    },
  },
  [`& .${treeItemClasses.group}`]: {
    marginLeft: 15,
    paddingLeft: 18,
    borderLeft: `1px dashed ${alpha(theme.palette.text.primary, 0.4)}`,
  },
}));

class ManagementView extends Component {
  constructor(props) {
    super(props);
    this.state = {}
  }

  handleChange = name => event => {
    //if (name == "question1") 
    //event.target.value
  }

  render() {
    return (
      <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
        <Grid container spacing={3}>

          {/* Chart */}
          <Grid item xs={12} md={4} lg={4}>

            <Paper
              sx={{
                p: 2,
                display: 'flex',
                flexDirection: 'column',
                height: 600,
              }}
            >
              <h2>BIM 360 Storage</h2>
              <TreeView
                aria-label="customized"
                defaultExpanded={['1']}
                defaultCollapseIcon={<MinusSquare />}
                defaultExpandIcon={<PlusSquare />}
                defaultEndIcon={<CloseSquare />}
                sx={{ height: 450, flexGrow: 1, maxWidth: "100%", overflowY: 'auto' }}
              >
                <StyledTreeItem nodeId="1" label="Rhoda Lake">
                  <StyledTreeItem nodeId="2" label="Rhoda Lake.dwf" />
                  <StyledTreeItem nodeId="3" label="FenceAssembly">
                    <StyledTreeItem nodeId="6" label="FencePostCorner.ipt" />
                    <StyledTreeItem nodeId="7" label="ChainLink.ipt" />
                    <StyledTreeItem nodeId="8" label="FencePostRegular.ipt" />
                  </StyledTreeItem>
                  <StyledTreeItem nodeId="4" label="Dead_End_and_Switch_138Kv.iam" />
                  <StyledTreeItem nodeId="5" label="CCVT_138Kv.iam" />
                </StyledTreeItem>
                <StyledTreeItem nodeId="10" label="Lamar">
                  <StyledTreeItem nodeId="11" label="Lamar.dwf" />
                  <StyledTreeItem nodeId="12" label="FenceAssembly">
                    <StyledTreeItem nodeId="16" label="Dead_End_and_Switch_138Kv.iam" />
                    <StyledTreeItem nodeId="17" label="CCVT_138Kv.iam" />
                    <StyledTreeItem nodeId="18" label="Transformer_138Kv.iam" />
                  </StyledTreeItem>
                  <StyledTreeItem nodeId="14" label="Current_Transformer_138Kv.iam" />
                  <StyledTreeItem nodeId="15" label="Cap Bank Breaker.iam" />
                </StyledTreeItem>
              </TreeView>
              <Alert variant="filled" severity="success">
                <AlertTitle>Normal</AlertTitle>
                All storage is synced and up to date
              </Alert>
            </Paper>
          </Grid>
          {/* Recent Deposits */}
          <Grid item xs={12} md={4} lg={4}>
            <Paper
              sx={{
                p: 2,
                display: 'flex',
                flexDirection: 'column',
                height: 600,
              }}
            >
              <h2>A360 Storage</h2>
              <TreeView
                aria-label="customized"
                defaultExpanded={['21']}
                defaultCollapseIcon={<MinusSquare />}
                defaultExpandIcon={<PlusSquare />}
                defaultEndIcon={<CloseSquare />}
                sx={{ height: 450, flexGrow: 1, maxWidth: "100%", overflowY: 'auto' }}
              >
                <StyledTreeItem nodeId="21" label="Rio Blanco">
                  <StyledTreeItem nodeId="22" label="Rio Blanco.dwf" />
                  <StyledTreeItem nodeId="23" label="FenceAssembly">
                    <StyledTreeItem nodeId="26" label="FencePostCorner.ipt" />
                    <StyledTreeItem nodeId="27" label="ChainLink.ipt" />
                    <StyledTreeItem nodeId="28" label="FencePostRegular.ipt" />
                  </StyledTreeItem>
                  <StyledTreeItem nodeId="24" label="Dead_End_and_Switch_138Kv.iam" />
                  <StyledTreeItem nodeId="25" label="CCVT_138Kv.iam" />
                </StyledTreeItem>
              </TreeView>
              <Alert variant="filled" severity="success">
                <AlertTitle>Normal</AlertTitle>
                All storage is synced and up to date
              </Alert>
            </Paper>
          </Grid>
          <Grid item xs={12} md={4} lg={4}>
            <Paper
              sx={{
                p: 2,
                display: 'flex',
                flexDirection: 'column',
                height: 600,
              }}
            >
              <h2>Synced Vault</h2>
              <TreeView
                aria-label="customized"
                defaultExpanded={['31']}
                defaultCollapseIcon={<MinusSquare />}
                defaultExpandIcon={<PlusSquare />}
                defaultEndIcon={<CloseSquare />}
                sx={{ height: 450, flexGrow: 1, maxWidth: "100%", overflowY: 'auto' }}
              >
                <StyledTreeItem nodeId="31" label="Saddle Ridge">
                  <StyledTreeItem nodeId="32" label="Saddle Ridge.dwf" />
                  <StyledTreeItem nodeId="33" label="FenceAssembly">
                    <StyledTreeItem nodeId="36" label="FencePostCorner.ipt" />
                    <StyledTreeItem nodeId="37" label="ChainLink.ipt" />
                    <StyledTreeItem nodeId="38" label="FencePostRegular.ipt" />
                  </StyledTreeItem>
                  <StyledTreeItem nodeId="34" label="Dead_End_and_Switch_138Kv.iam" />
                  <StyledTreeItem nodeId="35" label="CCVT_138Kv.iam" />
                </StyledTreeItem>
              </TreeView>
              <Alert variant="filled" severity="warning">
                <AlertTitle>Warning</AlertTitle>
                Remote Vault is offline and not synced
              </Alert>
            </Paper>
          </Grid>
          {/* Recent Orders */}
          <Grid item xs={12} md={4} lg={4}>
            <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
              <h2>BIM 360 Settings</h2>
              <Box
                component="form"
                sx={{
                  '& .MuiTextField-root': { m: 1, width: '25ch' },
                }}
                noValidate
                autoComplete="off"
              >
                <div>
                  <TextField
                    success
                    id="outlined-error"
                    label="User Name"
                    defaultValue="tscullion"
                  />
                  <TextField
                    success
                    id="outlined-error"
                    label="Password"
                    defaultValue="***********"
                  />
                  <FormControl sx={{ m: 1, width: '25ch' }} variant="outlined">
                    <InputLabel htmlFor="outlined-adornment-password">Auth Key</InputLabel>
                    <OutlinedInput
                      id="outlined-adornment-password"
                      type={'password'}
                      value={'*********************'}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"                            
                            edge="end"
                          >
                            <VisibilityOff/>
                          </IconButton>
                        </InputAdornment>
                      }
                      label="Password"
                    />
                  </FormControl>
                </div>
              </Box>

            </Paper>
          </Grid>

          <Grid item xs={12} md={4} lg={4}>
            <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
              <h2>A360 Settings</h2>
              <Box
                component="form"
                sx={{
                  '& .MuiTextField-root': { m: 1, width: '25ch' },
                }}
                noValidate
                autoComplete="off"
              >
                <div>
                  <TextField
                    success
                    id="outlined-error"
                    label="User Name"
                    defaultValue="tscullion"
                  />
                  <TextField
                    success
                    id="outlined-error"
                    label="Password"
                    defaultValue="***********"
                  />
                  <FormControl sx={{ m: 1, width: '25ch' }} variant="outlined">
                    <InputLabel htmlFor="outlined-adornment-password">Auth Key</InputLabel>
                    <OutlinedInput
                      id="outlined-adornment-password"
                      type={'password'}
                      value={'*********************'}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"                            
                            edge="end"
                          >
                            <VisibilityOff/>
                          </IconButton>
                        </InputAdornment>
                      }
                      label="Password"
                    />
                  </FormControl>
                </div>
              </Box>

            </Paper>
          </Grid>

          <Grid item xs={12} md={4} lg={4}>
            <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
              <h2>Network Settings</h2>
              <Box
                component="form"
                sx={{
                  '& .MuiTextField-root': { m: 1, width: '25ch' },
                }}
                noValidate
                autoComplete="off"
              >
                <div>
                  <TextField
                    success
                    id="outlined-error"
                    label="User Name"
                    defaultValue="tscullion"
                  />
                  <TextField
                    success
                    id="outlined-error"
                    label="Password"
                    defaultValue="***********"
                  />
                  <FormControl sx={{ m: 1, width: '25ch' }} variant="outlined">
                    <InputLabel htmlFor="outlined-adornment-password">Auth Key</InputLabel>
                    <OutlinedInput
                      id="outlined-adornment-password"
                      type={'password'}
                      value={'*********************'}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"                            
                            edge="end"
                          >
                            <VisibilityOff/>
                          </IconButton>
                        </InputAdornment>
                      }
                      label="Password"
                    />
                  </FormControl>
                </div>
              </Box>

            </Paper>
          </Grid>
        </Grid>

      </Container>
    )
  }
}

export default ManagementView;